var css = {"main":"VideoSideContents-module_main__J-yMA","video_container":"VideoSideContents-module_video_container__Hy-2r"};

export { css as default };
